<template>
  <q-expansion-item
    header-class="q-px-md q-py-md text-weight-medium"
    :expand-icon="`img:${ExpandIconUrl}`"
    :expanded-icon="`img:${ExpandedIconUrl}`"
    expand-icon-toggle
  >
    <template
      v-for="(slot, index) of Object.keys($slots)"
      :key="index"
      #[slot]="slotProps"
    >
      <slot v-if="slotProps" v-bind="slotProps" :name="slot"></slot>
      <slot v-else :name="slot"></slot>
    </template>
    <template #default>
      <slot></slot>
    </template>
  </q-expansion-item>
</template>
<script setup>
import ExpandIconUrl from "assets/icons/expand-brown.svg?url";
import ExpandedIconUrl from "assets/icons/expanded-brown.svg?url";
</script>
